module.exports = __webpack_public_path__ + "media/assets/images/flags/cd-0ff4d9f40251b093bfecf27c18b08d5d.svg";